import { z } from 'zod'

import type {
  NotificationInboxDto,
  NotificationInboxIndexQuery,
  NotificationInboxIndexSuccess
} from '~/services/api/generated'

export type NotificationInboxItem = NotificationInboxDto
export type NotificationInboxLinks = NotificationInboxIndexSuccess['links']
export type NotificationInboxMeta = NotificationInboxIndexSuccess['meta']
export type NotificationInboxResponse = NotificationInboxIndexSuccess

export type NotificationInboxQuery = NotificationInboxIndexQuery

export const NotificationInboxSelectionSchema = z.strictObject({
  notifications: z.array(z.uuid()).min(1)
})

export type NotificationDeleteBatchPayload = z.infer<typeof NotificationInboxSelectionSchema>

// Realtime pushes never carry the inbox-only bookkeeping fields (is_read/read_at);
// the title/body/action_label fields are always null since realtime events are
// always template-driven (see notificationCloudEvent.ts unwrapNotificationCloudEvent).
export type RealtimeNotificationPayload = Omit<NotificationInboxItem, 'is_read' | 'read_at'> & {
  dedupe_key?: string | null
}
